module.exports = __webpack_public_path__ + "img/Bodice-Front-B3-Gb-Da-Eb.df5eb67e.png";